import{jsx as o}from"react/jsx-runtime";import{styled as t}from"styled-components";const r=t.label`
  font-family: Consolas;
  margin-bottom: 3px;
`;function m({masterName:t}){return o(r,{children:t})}export{m as NameLabel};
